import { useNavigate } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />

      <div className="max-w-4xl mx-auto px-6 pt-28 pb-12 sm:pt-36 sm:pb-20">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-4xl font-black text-[#1B4332] mb-6" style={{ fontFamily: 'Nunito, sans-serif' }}>Privacy Policy</h2>
          <p className="text-[#1B4332]/80 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>1. Information We Collect</h3>
            <p className="text-[#1B4332]/80 mb-4">
              At PurrCheck, we collect information necessary to provide you with our AI-powered cat food analysis service:
            </p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>Account information (email, name)</li>
              <li>Cat profile data (name, breed, age, weight, health notes)</li>
              <li>Food ingredient scans and analysis results</li>
              <li>Behavior chat conversations</li>
              <li>Usage data and analytics</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>2. Data Storage</h3>
            <p className="text-[#1B4332]/80 mb-4">
              Your data is securely stored using Supabase, a PostgreSQL database platform with enterprise-grade security. 
              We implement industry-standard encryption and security practices to protect your information.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>3. AI Processing</h3>
            <p className="text-[#1B4332]/80 mb-4">
              PurrCheck uses Google Gemini AI to analyze cat food ingredients and provide behavior guidance. 
              When you use our ingredient checker or behavior chat features, your data is processed by Gemini AI to generate personalized recommendations. 
              We do not store your data on Google servers beyond the analysis process.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>4. Affiliate Links</h3>
            <p className="text-[#1B4332]/80 mb-4">
              PurrCheck contains affiliate links to products on Amazon and Chewy. When you make a purchase through these links, 
              we may earn a commission at no additional cost to you. This helps us maintain and improve our service.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>5. Data Sharing</h3>
            <p className="text-[#1B4332]/80 mb-4">
              <strong>We never sell your personal data.</strong> Your information is not shared with third parties except:
            </p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>When required by law</li>
              <li>To provide our core services (Supabase for storage, Gemini for AI analysis)</li>
              <li>With your explicit consent</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>6. Your Rights</h3>
            <p className="text-[#1B4332]/80 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-[#1B4332]/80 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Delete your account and all associated data</li>
              <li>Export your data</li>
              <li>Opt-out of marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>7. Cookies</h3>
            <p className="text-[#1B4332]/80 mb-4">
              We use cookies to maintain your session and improve your experience. These are essential for the service to function properly.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-2xl font-bold text-[#1B4332] mb-4" style={{ fontFamily: 'Nunito, sans-serif' }}>8. Contact Us</h3>
            <p className="text-[#1B4332]/80 mb-4">
              For any privacy-related questions or concerns, please contact us at:
            </p>
            <p className="text-[#1B4332]/80">
              <strong>Email:</strong> <a href="mailto:privacy@purrcheck.com" className="text-primary hover:underline">privacy@purrcheck.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;